export default function StatusMessage({
  tone = 'info',
  message,
  style,
}) {
  if (!message) {
    return null;
  }

  const toneStyles = {
    info: {
      backgroundColor: '#eff6ff',
      borderColor: '#bfdbfe',
      color: '#1d4ed8',
    },
    success: {
      backgroundColor: '#f0fdf4',
      borderColor: '#bbf7d0',
      color: '#166534',
    },
    error: {
      backgroundColor: '#fef2f2',
      borderColor: '#fecaca',
      color: '#b91c1c',
    },
  };

  const activeTone = toneStyles[tone] || toneStyles.info;

  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      style={{
        border: `1px solid ${activeTone.borderColor}`,
        backgroundColor: activeTone.backgroundColor,
        color: activeTone.color,
        borderRadius: 12,
        padding: '12px 14px',
        fontSize: 14,
        lineHeight: 1.5,
        ...style,
      }}
    >
      {message}
    </div>
  );
}
